export default "__VITE_ASSET__CMKdF25E__"